<template>
  <div class="loading_containr">
      <div v-if="isTwo" class="loading_img"></div>
      <div v-else class="loading_img2">
          <svg t="1603357072936" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3555" width="24" height="24">
      <linearGradient id="Gradient" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stop-color="rgba(55, 105, 208, 1)"/>
        <stop offset="100%" stop-color="rgba(55, 104, 207, 1)"/>
      </linearGradient>
      <path d="M805.701818 379.159273L474.577455 710.376727a46.359273 46.359273 0 0 1-65.629091 0L218.298182 519.726545a46.359273 46.359273 0 0 1 65.536-65.62909l157.882182 157.975272 298.449454-298.449454a46.359273 46.359273 0 0 1 65.536 65.536M512 0a512 512 0 1 0 0 1024 512 512 0 0 0 0-1024" fill="url(#Gradient)" p-id="3556"></path>
    </svg>
      </div>
      <div class="txt">{{msg}}<span style="color:#2660ce">{{time}}</span></div>
  </div>
</template>

<script>
export default {
    name: 'loading',
    data() {
        return {
            msg: '大数据匹配中，请您耐心等候…',
            time:10,
            isTwo: true
        }
    },

    watch: {
        isTrue(newVal, oldVal) {
            console.log(newVal)
        }
    },

    mounted() {
        this.loadingTime()
    },

    methods: {
        
        loadingTime() {
            this.timer = setInterval(()=>{
                if(this.time>0) {
                    this.time--
                } else {
                    this.qiehuan()
                }
            }, 1000)
        },

        qiehuan() {
            window.clearInterval(this.timer)
            this.msg = '',
            this.isTwo = false
            setTimeout(() => {
                this.msg = '大数据匹配中，请您耐心等候…'
                this.isTwo = true
                this.time = 10
                // this.setTimeout()
            }, 500)
        },
    }
}
</script>

<style lang="less" scoped>
.loading_containr {
    width: 300px;
    height: 160PX;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    // padding: 0 120px;
    .loading_img {
        margin: 0 auto;
        background-image: url('./jqr.svg');
        background-size: 31px 31px;
        width: 31px;
        height: 31px;
        animation: mymove 2s infinite ease-in-out;
    }
    .loading_img2 {
        background-size: 31px 31px;
        width: 31px;
        height: 31px;
        // background-color: pink;
        animation: mymove2 0.5s forwards ease-in-out;
    }
    .txt {
        margin-top: 15px;
        font-size:16px;
        font-weight: 400;
        color: #3B3B3B;
    }
}

@keyframes mymove{
    0% {
        transform: perspective(120px) rotateY(0deg) rotateX(0deg);
        -webkit-transform: perspective(120px) rotateY(0deg) rotateX(0deg);
    } 33% {
        transform: perspective(120px) rotateY(179.9deg) rotateX(0deg);
        -webkit-transform: perspective(120px) rotateY(179.9deg) rotateX(0deg);
    } 66% {
        transform: perspective(120px) rotateY(179.9deg) rotateX(-180deg);
        -webkit-transform: perspective(120px) rotateY(179.9deg) rotateX(-180deg);
    }
    100% {
        transform: perspective(120px) rotateY(179.9deg) rotateX(-360deg);
        -webkit-transform: perspective(120px) rotateY(179.9deg) rotateX(-360deg);
    }
}

@keyframes mymove2 {
    0% {
        transform: scale(0.7);
        opacity: 0;
    } 70% {
        transform: scale(1.2);
        opacity: 1;
    } 100% {
        transform: scale(1);
        opacity: 1;
    }
}

</style>


// WEBPACK FOOTER //
// src/modules/Loadings/index.vue